<template>
  <div class="tools-page">
    <WorldClock />
    <!-- 功能入口卡片 -->
    <section class="feature-cards">
      <h2 class="section-title">时间工具</h2>
      <div class="cards-grid">
        <router-link to="/calendar" class="feature-card card-calendar">
          <span class="card-icon">&#128197;</span>
          <span class="card-label">日历</span>
          <span class="card-desc">年历·周数·日期差</span>
        </router-link>
        <router-link to="/convert" class="feature-card card-convert">
          <span class="card-icon">&#128339;</span>
          <span class="card-label">时区转换</span>
          <span class="card-desc">多时区时间对比</span>
        </router-link>
        <router-link to="/cities" class="feature-card card-cities">
          <span class="card-icon">&#127758;</span>
          <span class="card-label">全球城市</span>
          <span class="card-desc">300+城市实时时间</span>
        </router-link>
        <router-link to="/" class="feature-card card-codes">
          <span class="card-icon">&#128205;</span>
          <span class="card-label">国家地区代码</span>
          <span class="card-desc">ISO 3166·电话区号</span>
        </router-link>
      </div>
    </section>
    <!-- 快捷城市 -->
    <section class="quick-cities">
      <h2 class="section-title">热门城市</h2>
      <div class="quick-cities-grid">
        <router-link
          v-for="c in quickCities"
          :key="c.name"
          :to="`/city/${c.name}`"
          class="quick-city-card"
        >
          <div class="qc-name">{{ c.label }}</div>
          <div class="qc-time">{{ c.time }}</div>
          <div class="qc-offset">{{ c.offset }}</div>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import WorldClock from '../components/WorldClock.vue'

const QUICK_CITIES = [
  { name: 'Tokyo', label: '东京', tz: 'Asia/Tokyo' },
  { name: 'Beijing', label: '北京', tz: 'Asia/Shanghai' },
  { name: 'Singapore', label: '新加坡', tz: 'Asia/Singapore' },
  { name: 'Dubai', label: '迪拜', tz: 'Asia/Dubai' },
  { name: 'Moscow', label: '莫斯科', tz: 'Europe/Moscow' },
  { name: 'London', label: '伦敦', tz: 'Europe/London' },
  { name: 'Paris', label: '巴黎', tz: 'Europe/Paris' },
  { name: 'New_York', label: '纽约', tz: 'America/New_York' },
  { name: 'Los_Angeles', label: '洛杉矶', tz: 'America/Los_Angeles' },
  { name: 'Sydney', label: '悉尼', tz: 'Australia/Sydney' },
  { name: 'Hong_Kong', label: '香港', tz: 'Asia/Hong_Kong' },
  { name: 'Seoul', label: '首尔', tz: 'Asia/Seoul' },
  { name: 'Toronto', label: '多伦多', tz: 'America/Toronto' },
  { name: 'Sao_Paulo', label: '圣保罗', tz: 'America/Sao_Paulo' },
  { name: 'Mumbai', label: '孟买', tz: 'Asia/Kolkata' },
  { name: 'Berlin', label: '柏林', tz: 'Europe/Berlin' }
]

export default {
  name: 'TimeToolsPage',
  components: { WorldClock },
  data() {
    return {
      quickCities: [],
      timer: null,
      is24h: localStorage.getItem('worldclock-is24h') !== 'false'
    }
  },
  mounted() {
    this.updateCities()
    this.timer = setInterval(this.updateCities, 10000)
    window.addEventListener('storage', this.onStorageChange)
    window.addEventListener('worldclock-24h-changed', this.on24hChanged)
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer)
    window.removeEventListener('storage', this.onStorageChange)
    window.removeEventListener('worldclock-24h-changed', this.on24hChanged)
  },
  methods: {
    updateCities() {
      const now = new Date()
      const hour12 = !this.is24h
      this.quickCities = QUICK_CITIES.map(c => {
        const parts = new Intl.DateTimeFormat('zh-CN', {
          timeZone: c.tz, hour: 'numeric', minute: '2-digit', hour12
        }).formatToParts(now)
        const hour = parts.find(p => p.type === 'hour')?.value || '00'
        const minute = parts.find(p => p.type === 'minute')?.value || '00'
        const dayPeriod = parts.find(p => p.type === 'dayPeriod')?.value || ''
        const time = hour12 && dayPeriod
          ? `${dayPeriod} ${hour.padStart(2, '0')}:${minute}`
          : `${hour.padStart(2, '0')}:${minute}`
        let offset = ''
        try {
          const parts = new Intl.DateTimeFormat('en-US', { timeZone: c.tz, timeZoneName: 'shortOffset' }).formatToParts(now)
          const o = parts.find(p => p.type === 'timeZoneName')
          if (o) offset = o.value
        } catch (e) { /* ignore */ }
        return { ...c, time, offset }
      })
    },
    onStorageChange(e) {
      if (e.key === 'worldclock-is24h') {
        this.is24h = e.newValue !== 'false'
        this.updateCities()
      }
    },
    on24hChanged(e) {
      this.is24h = e.detail
      this.updateCities()
    }
  }
}
</script>

<style scoped>
.tools-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 16px 30px;
}

/* 功能入口卡片 */
.feature-cards {
  margin-top: 24px;
}
.section-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 14px;
  padding-left: 4px;
}
.cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}
.feature-card {
  background: #fff;
  border-radius: 12px;
  padding: 22px 16px;
  text-align: center;
  text-decoration: none;
  color: #333;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  border-top: 3px solid transparent;
}
.feature-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.1);
}
.card-calendar { border-top-color: #e74c3c; }
.card-convert { border-top-color: #3498db; }
.card-cities { border-top-color: #2ecc71; }
.card-codes { border-top-color: #9b59b6; }
.card-icon { font-size: 28px; }
.card-label { font-size: 15px; font-weight: 600; }
.card-desc { font-size: 12px; color: #999; }

/* 快捷城市 */
.quick-cities {
  margin-top: 28px;
}
.quick-cities-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.quick-city-card {
  background: #fff;
  border-radius: 10px;
  padding: 16px 12px;
  text-align: center;
  text-decoration: none;
  color: #333;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
  transition: all 0.2s;
}
.quick-city-card:hover {
  background: #f0f5ff;
  transform: translateY(-1px);
  box-shadow: 0 3px 12px rgba(0,0,0,0.08);
}
.qc-name { font-size: 14px; font-weight: 600; margin-bottom: 4px; }
.qc-time {
  font-size: 22px;
  font-weight: 300;
  font-family: 'SF Mono', 'Consolas', 'Menlo', monospace;
  color: #1a1a2e;
}
.qc-offset { font-size: 11px; color: #1677ff; margin-top: 2px; font-weight: 600; }

@media (max-width: 768px) {
  .cards-grid { grid-template-columns: repeat(2, 1fr); }
  .quick-cities-grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 480px) {
  .quick-cities-grid { grid-template-columns: repeat(2, 1fr); }
}
</style>
